import { render } from "./SelectProp.vue?vue&type=template&id=364bf8c2&scoped=true"
import script from "./SelectProp.vue?vue&type=script&lang=js"
export * from "./SelectProp.vue?vue&type=script&lang=js"

import "./SelectProp.vue?vue&type=style&index=0&id=364bf8c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364bf8c2"]])

export default __exports__